// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-page {
  background-color: rgba(var(--white));
}
.contacts-page__header {
  padding: 3rem 6.875rem 0;
}
@media (max-width: 768px) {
  .contacts-page__header {
    padding: 1.75rem 1rem 1.25rem;
    height: 2.5rem;
  }
}
.contacts-page__content {
  padding: 0 6.875rem 3rem;
}
@media (max-width: 768px) {
  .contacts-page__content {
    padding: 0;
  }
}
.contacts-page__title {
  font-size: 2rem;
  line-height: 1.3;
  font-weight: 500;
  color: rgba(var(--grey-800));
}
@media (max-width: 768px) {
  .contacts-page__title {
    font-size: 1.5rem;
    line-height: 1.3;
    padding: 0 1rem;
    margin-top: 0.75rem;
  }
}
.contacts-page__blocks {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin-top: 3rem;
  margin-bottom: 4.5rem;
}
@media (max-width: 768px) {
  .contacts-page__blocks {
    margin: 2rem 1rem 0;
  }
}
.contacts-page__blocks-item {
  height: 18.75rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: rgba(var(--grey-100));
  border-radius: 0.5rem;
}
@media (max-width: 768px) {
  .contacts-page__blocks-item {
    flex-direction: column;
    height: auto;
    gap: 1rem;
  }
}
.contacts-page-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
  margin: 1rem 1.5rem;
}
@media (max-width: 768px) {
  .contacts-page-info {
    margin: 1rem;
    gap: 0.5rem;
  }
}
.contacts-page-info__social {
  margin-left: 0.5rem;
  font-weight: 500;
}
@media (max-width: 768px) {
  .contacts-page-info__social {
    margin-left: 0;
    display: block;
  }
}
.contacts-page-info__social a {
  color: rgba(var(--blue));
}
.contacts-page-info__text-title {
  color: rgba(var(--grey-600));
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 400;
}
.contacts-page-info__text-content {
  color: rgba(var(--grey-800));
  font-size: 1rem;
  line-height: 1.625;
  font-weight: 600;
}
.contacts-page-info_gap {
  gap: 1.5rem;
}
@media (max-width: 768px) {
  .contacts-page-info_gap {
    gap: 0.5rem;
  }
}
.contacts-page-map {
  flex: 1 1;
}
.contacts-page-map__item {
  border-radius: 1rem;
  overflow: hidden;
}

.ymaps-2-1-79-map {
  border-radius: 1rem;
  overflow: hidden;
}

.ymaps-2-1-79-gototech,
.ymaps-2-1-79-copyright__wrap {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Contacts/styles.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,6BAAA;IACA,cAAA;EAEJ;AACF;AACE;EACE,wBAAA;AACJ;AACI;EAHF;IAII,UAAA;EAEJ;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AACJ;AACI;EANF;IAOI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,mBAAA;EAEJ;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AACJ;AACI;EAPF;IAQI,mBAAA;EAEJ;AACF;AAAI;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,uCAAA;EACA,qBAAA;AAEN;AAAM;EARF;IASI,sBAAA;IACA,YAAA;IACA,SAAA;EAGN;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EAPF;IAQI,YAAA;IACA,WAAA;EAEJ;AACF;AAAI;EACE,mBAAA;EACA,gBAAA;AAEN;AAAM;EAJF;IAKI,cAAA;IACA,cAAA;EAGN;AACF;AADM;EACE,wBAAA;AAGR;AAEM;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAEM;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAAR;AAII;EACE,WAAA;AAFN;AAIM;EAHF;IAII,WAAA;EADN;AACF;AAKE;EACE,SAAA;AAHJ;AAKI;EACE,mBAAA;EACA,gBAAA;AAHN;;AAQA;EACE,mBAAA;EACA,gBAAA;AALF;;AAQA;;EAEE,wBAAA;AALF","sourcesContent":[".contacts-page {\n  background-color: rgba(var(--white));\n\n  &__header {\n    padding: 3rem 6.875rem 0;\n\n    @media (max-width: 768px) {\n      padding: 1.75rem 1rem 1.25rem;\n      height: 2.5rem;\n    }\n  }\n\n  &__content {\n    padding: 0 6.875rem 3rem;\n\n    @media (max-width: 768px) {\n      padding: 0;\n    }\n  }\n\n  &__title {\n    font-size: 2rem;\n    line-height: 1.3;\n    font-weight: 500;\n    color: rgba(var(--grey-800));\n\n    @media (max-width: 768px) {\n      font-size: 1.5rem;\n      line-height: 1.3;\n      padding: 0 1rem;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &__blocks {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5rem;\n    margin-top: 3rem;\n    margin-bottom: 4.5rem;\n\n    @media (max-width: 768px) {\n      margin: 2rem 1rem 0;\n    }\n\n    &-item {\n      height: 18.75rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      background-color: rgba(var(--grey-100));\n      border-radius: 0.5rem;\n\n      @media (max-width: 768px) {\n        flex-direction: column;\n        height: auto;\n        gap: 1rem;\n      }\n    }\n  }\n\n  &-info {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    flex: 1;\n    margin: 1rem 1.5rem;\n\n    @media (max-width: 768px) {\n      margin: 1rem;\n      gap: 0.5rem;\n    }\n\n    &__social {\n      margin-left: 0.5rem;\n      font-weight: 500;\n\n      @media (max-width: 768px) {\n        margin-left: 0;\n        display: block;\n      }\n\n      a {\n        color: rgba(var(--blue));\n      }\n    }\n\n    &__text {\n      &-title {\n        color: rgba(var(--grey-600));\n        font-size: 1rem;\n        line-height: 1.625;\n        font-weight: 400;\n      }\n      &-content {\n        color: rgba(var(--grey-800));\n        font-size: 1rem;\n        line-height: 1.625;\n        font-weight: 600;\n      }\n    }\n\n    &_gap {\n      gap: 1.5rem;\n\n      @media (max-width: 768px) {\n        gap: 0.5rem;\n      }\n    }\n  }\n\n  &-map {\n    flex: 1;\n\n    &__item {\n      border-radius: 1rem;\n      overflow: hidden;\n    }\n  }\n}\n\n.ymaps-2-1-79-map {\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.ymaps-2-1-79-gototech,\n.ymaps-2-1-79-copyright__wrap {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
